<template>
  <div>
    <LandingPageLayout :layout="pageLayout" :components="{}" />
  </div>
</template>
<script setup lang="ts">
import { LandingPageLayout } from '@ramp106/omrjs-hygraph-ui'
import { storeToRefs } from 'pinia'
import { computed, watch, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useContentPages } from '@/composables/useContentPages'
import { Locale, useLandingPageBySlugLazyQuery, type LandingPageBySlugQuery } from '@/gql/hygraph/hygraph.generated'
import { useLocaleStore, useMeStore } from '@/stores'

const { me } = storeToRefs(useMeStore())

const router = useRouter()
const route = useRoute()
const { getContentSlug } = useContentPages()

const page = ref<LandingPageBySlugQuery>()

const localeStore = useLocaleStore()
const { locale } = storeToRefs(localeStore)
const requestLocale = ref<'en' | 'de'>(locale.value)

const contentSlug = computed(() => {
  return getContentSlug.value(route.params.slug as string, !!me)
})

const pageLayout = computed(() => {
  return page.value?.landingPage?.pageLayout ?? []
})

function landingPageVariables(slug: string, language: string) {
  const pageLocale = language === 'en' ? Locale.En : Locale.De
  const fallbackLocale = pageLocale === Locale.En ? Locale.De : Locale.En
  return { slug, locale: [pageLocale], imageLocales: [pageLocale, fallbackLocale] }
}

const { load, refetch, onResult } = useLandingPageBySlugLazyQuery(landingPageVariables('', requestLocale.value), {
  clientId: 'hygraph',
})

onResult((pageData) => {
  page.value = pageData?.data
})

watch(
  () => contentSlug.value,
  (newSlug) => {
    switch (newSlug) {
      case '404': {
        router.push({ name: '404' })
        break
      }
      case 'NA': {
        break
      }
      default: {
        load(null, landingPageVariables(newSlug, requestLocale.value))
      }
    }
  },
  { immediate: true },
)

watch(
  () => locale.value,
  (newLocale) => {
    refetch(landingPageVariables(contentSlug.value, newLocale))
  },
)
</script>
